<footer class="footer-container">
  <div class="footer-content">
    <div class="footer-logo">
      <img [src]="cdnBase + '/logo-3.png'" alt="logo-text" class="logo" />
      <p class="tagline">The Premium <span class="highlight">RUST Unboxing and Case Battles</span> experience.</p>
      <p class="disclaimer">
        Gambling should be fun and entertaining. If you ever feel it's becoming a problem, please gamble responsibly. For support, visit
        <a href="https://www.begambleaware.org" target="_blank">BeGambleAware.org</a> or contact a gambling support service in your area.
      </p>
      <p class="copyright">© {{ currentYear }} RustKing. All Rights Reserved.</p>
    </div>

    <div class="footer-links">
      <div class="footer-column">
        <h3>GAMES</h3>
        <ul>
          <li><a routerLink="/battles">Case Battles</a></li>
          <li><a routerLink="/coinflip">Coinflip</a></li>
          <li><a routerLink="/king">King</a></li>
          <li><a routerLink="/jackpot">Jackpot</a></li>
          <li><a routerLink="/mines">Mines</a></li>
          <li><a routerLink="/towers">Towers</a></li>
          <li><a routerLink="/cases">Case Opening</a></li>
          <li><a routerLink="/plinko">Plinko</a></li>
        </ul>
      </div>

      <div class="footer-column">
        <h3>REWARDS</h3>
        <ul>
          <li><a routerLink="/rewards">Daily Cases</a></li>
          <li><a routerLink="/leaderboard">Leaderboard</a></li>
          <li><a routerLink="/raffles">Raffles</a></li>
          <li><a routerLink="/rewards">Faucet</a></li>
          <li><a routerLink="/rewards">Rakeback</a></li>
          <!--          <li><a routerLink="/website">Website Promotion</a></li>-->
        </ul>
      </div>

      <div class="footer-column">
        <h3>INFORMATION</h3>
        <ul>
          <li><a routerLink="/provably-fair">Fairness</a></li>
          <li><a routerLink="/faq">Questions</a></li>
          <li><a (click)="openSupportModal()">Support</a></li>
          <li><a routerLink="/tos">Terms of Service</a></li>
        </ul>
      </div>

      <div class="footer-column">
        <h3>SOCIAL</h3>
        <ul>
          <li class="link-icon">
            <app-icon [icon]="'twitter'" [pathFill]="'#787676'"></app-icon>
            <a href="https://twitter.com" target="_blank">Twitter</a>
          </li>
          <li class="link-icon">
            <app-icon [icon]="'discord'" [pathFill]="'#787676'"></app-icon>
            <a href="https://discord.com/invite/skinbetgg" target="_blank">Discord</a>
          </li>
        </ul>
      </div>
    </div>
  </div>

  <div class="payment-methods">
    <app-icon [icon]="'rust'" [width]="32" class="payment-icon" (click)="openDepositModal('rust')"></app-icon>
    <app-icon [icon]="'cs'" [width]="32" class="payment-icon" (click)="openDepositModal('games')"></app-icon>
    <app-icon [icon]="'dota'" [width]="32" class="payment-icon" (click)="openDepositModal('games')"></app-icon>
    <app-icon [icon]="'bitcoin'" [width]="32" class="payment-icon" (click)="openDepositModal('crypto', 'bitcoin')"></app-icon>
    <app-icon [icon]="'ethereum'" [width]="32" class="payment-icon" (click)="openDepositModal('crypto', 'ethereum')"></app-icon>
    <app-icon [icon]="'litecoin'" [width]="32" class="payment-icon" (click)="openDepositModal('crypto', 'litecoin')"></app-icon>
    <img [src]="cdnBase + '/withdraw/kinguin-logo.png'" alt="kinguin-logo" class="payment-img" (click)="openDepositModal('kinguin')" />
  </div>
</footer>
